module.exports = __webpack_public_path__ + "img/exit.d463a149.png";